module.exports = __webpack_public_path__ + "static/media/eng_d_2235.9a344354.vtt";